import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-market_facebook",
  "use": "icon-market_facebook-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-market_facebook\">\n<path d=\"M22.8 12.0657C22.8 6.06324 17.9661 1.19995 12 1.19995C6.03382 1.19995 1.19995 6.06324 1.19995 12.0657C1.19995 17.4889 5.14935 21.9841 10.3125 22.8V15.2067H7.5689V12.0657H10.3125V9.67171C10.3125 6.94871 11.9237 5.44459 14.3916 5.44459C15.5735 5.44459 16.8094 5.65665 16.8094 5.65665V8.32927H15.4472C14.106 8.32927 13.6875 9.16698 13.6875 10.0262V12.0657H16.6827L16.2037 15.2067H13.6875V22.8C18.8505 21.9841 22.8 17.4889 22.8 12.0657Z\" fill=\"#4267B2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/market_facebook.svg
// module id = zjBL
// module chunks = 262